var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeInactive = function SvgHomeInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A8A8A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.731 2.585 3.379 7.672c-.715.569-1.174 1.77-1.018 2.668l1.22 7.297c.22 1.301 1.466 2.355 2.786 2.355h10.267c1.31 0 2.566-1.063 2.786-2.355l1.22-7.297c.146-.898-.312-2.1-1.018-2.668l-6.353-5.078c-.98-.788-2.566-.788-3.538-.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A8A8A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.5 14.208a2.292 2.292 0 1 0 0-4.583 2.292 2.292 0 0 0 0 4.583"
  })));
};
export default SvgHomeInactive;